import WebLayout from "../../components/WebLayout.jsx";
import Landing from "../../components/landing/Landing.jsx";
import WorkInfo from "./workInfo/WorkInfo.jsx";
import axios from "axios";
import { baseUrl, getServiceDetail } from "../../utils/apiData.js";
import { Fragment, useEffect, useState } from "react";
import Loader from "../../components/loader/Loader.jsx";
import { useLocation, useParams } from "react-router-dom";
import { LogoSlider } from "../about/index.js";

const ServiceDatail = () => {
  const { slug } = useParams();

  const [loader, setLoader] = useState(false);
  const [caseStudy, setCaseStudy] = useState({});
  const [imgList, setImgList] = useState([]);

  const getBlogDetailApi = async () => {
    setLoader(true);
    try {
      const res = await axios.post(`${baseUrl}/${getServiceDetail}`, {
        slug,
      });
      if (res?.data?.success) {
        setCaseStudy(res?.data?.data);
        setImgList(res?.data?.data?.sliderimages);
      }
    } catch (error) {
      console.log(error);
    }
    setLoader(false);
  };

  useEffect(() => {
    getBlogDetailApi();
  }, [slug]);

  return (
    <WebLayout>
      {loader ? (
        <Loader />
      ) : (
        <Fragment>
          <Landing title={caseStudy?.name} />
          <WorkInfo data={caseStudy} />
          {imgList?.length > 0 && <LogoSlider dataList={imgList} />}
        </Fragment>
      )}
    </WebLayout>
  );
};

export default ServiceDatail;
